const {
  concat,
  either,
  equals,
  init,
  isNil,
  join,
  reduce,
  replace,
  split,
  toPairs,
} = require('ramda')

const qs = require('qs')

const getHistory = require('./history')

/**
 * Returns the current URL path without the query string.
 */
function getPathname () {
  const url = new URL(window.location.href)
  return url.pathname
}

/**
 * Returns the current URL path including the query string.
 */
function getPathWithQuery () {
  const url = new URL(window.location.href)
  const path = url.pathname
  const query = url.search
  const pathWithQuery = concat(path, query)
  return pathWithQuery
}

/**
 * A helper method to determine if a given route, params, and query
 * are active.
 */
function isActive (to, params, query) {
  const current = window.location.href
  const toNew = concat(to, params, query)
  return equals(current, toNew)
}

function getMatch (path) {
  return window.location.pathname.includes(path)
}

/**
 * Returns parent route
 */
function getParentRoute (url) {
  return join('/', init(split('/', url)))
}

function parseQueryString (queryString) {
  return qs.parse(decodeURI(queryString.substring(1)))
}

/**
 * Returns an object of the query params that are currently active.
 */
function getQuery () {
  return parseQueryString(window.location.search)
}

function createQuery (query) {
  return equals({}, query)
    ? ''
    : encodeURI(`?${qs.stringify(query, { arrayFormat: 'brackets' })}`)
}

function createURL (template, params, queryObj) {
  const base = reduce((acc, item) => {
    const [ key, value ] = item
    return replace(new RegExp(`:${key}`), value, acc)
  }, template, toPairs(params))
  return either(isNil, equals({}))(queryObj) ? base : `${base}${createQuery(queryObj)}`
}

function goToURL (url) {
  getHistory().push(url)
}

function adjustQuery (newQuery) {
  const finalQuery = Object.assign(getQuery(), newQuery)
  return createQuery(finalQuery)
}

module.exports = {
  adjustQuery,
  getParentRoute,
  getMatch,
  getPathname,
  getPathWithQuery,
  getQuery,
  goToURL,
  isActive,
  createQuery,
  createURL,
  parseQueryString,
}
